__turbopack_context__.v({
  "applyCta": "card-module-scss-module__FaFb5a__applyCta",
  "bgWhite": "card-module-scss-module__FaFb5a__bgWhite",
  "card": "card-module-scss-module__FaFb5a__card",
  "container": "card-module-scss-module__FaFb5a__container",
  "darkBlue": "card-module-scss-module__FaFb5a__darkBlue",
  "description": "card-module-scss-module__FaFb5a__description",
  "grey": "card-module-scss-module__FaFb5a__grey",
  "headline": "card-module-scss-module__FaFb5a__headline",
  "image": "card-module-scss-module__FaFb5a__image",
  "italicDescription": "card-module-scss-module__FaFb5a__italicDescription",
  "popupContent": "card-module-scss-module__FaFb5a__popupContent",
  "tagContainer": "card-module-scss-module__FaFb5a__tagContainer",
  "tooltip": "card-module-scss-module__FaFb5a__tooltip",
  "topImageContainer": "card-module-scss-module__FaFb5a__topImageContainer",
});
